import { Routes, Route, Navigate } from 'react-router-dom';
import { RootRedirect } from './routes/RootRedirect';
import { ProtectedRoute } from './routes/ProtectedRoute';
import { AdminPage } from './pages/AdminPage';
import { ValidarPage } from './pages/ValidarPage';
import { LoginPage } from './pages/LoginPage';
import { LandingPage } from './pages/LandingPage';
import { ComprarPage, GraciasPage } from './pages/ComprarPage';
import { CuentaPage } from './pages/CuentaPage';
import { MiOrgPage } from './pages/MiOrgPage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { BolsilloPage } from './pages/BolsilloPage';
import { CabinaPage } from './pages/CabinaPage';
import { ProcesosPage } from './pages/ProcesosPage';
import { ParticipantesPage } from './pages/ParticipantesPage';
import { CompositorPage } from './pages/CompositorPage';
import { PantallaPage } from './pages/PantallaPage';
import { PropuestaPage } from './pages/PropuestaPage';
import { DashboardPage } from './pages/DashboardPage';
import { NuevoPage } from './pages/NuevoPage';
import { StyleguidePage } from './pages/StyleguidePage';
import { PrivacidadPage } from './pages/PrivacidadPage';
import { TerminosPage } from './pages/TerminosPage';
import { ResultadoPage } from './pages/ResultadoPage';

/**
 * Router de ÁGORA (F0-P4). Superficies:
 *   /login              — tres vías de acceso (correo, Google, sala)
 *   /                   — redirige según sesión y rol
 *   /app                — Bolsillo (participante)   [protegida]
 *   /procesos           — portada del conductor      [protegida]
 *   /cabina             — Cabina (facilitador)      [protegida]
 *   /pantalla/:sesionId — Pantalla (proyección)     [protegida]
 *   /propuesta/:procesoId — Propuesta v0 trazable   [protegida]
 *   /tablero/:procesoId — Tablero de agregados      [protegida]
 *   /nuevo              — entrada por problema       [protegida]
 *   /styleguide         — guía de estilo viva (solo dev)
 */
export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/privacidad" element={<PrivacidadPage />} />
      <Route path="/terminos" element={<TerminosPage />} />
      <Route path="/styleguide" element={<StyleguidePage />} />
      {/* Validación de documentos: link directo; la página gestiona su login Google. */}
      {/* La devolución a quien validó: pública como el portal de
            validación, con su propio portón de Google. */}
        <Route path="/resultado/:procesoId" element={<ResultadoPage />} />
        <Route path="/validar/:actividadId" element={<ValidarPage />} />
      {/* La raíz es la landing pública (planes + puerta); /entrar conserva la
          redirección por rol de siempre para quien ya tiene sesión. */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/entrar" element={<RootRedirect />} />
      <Route path="/pago/gracias" element={<GraciasPage />} />

      {/* Rutas que exigen sesión */}
      <Route element={<ProtectedRoute />}>
        <Route path="/app" element={<BolsilloPage />} />
        <Route path="/procesos" element={<ProcesosPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/comprar/:plan" element={<ComprarPage />} />
        <Route path="/cuenta" element={<CuentaPage />} />
        <Route path="/organizacion" element={<MiOrgPage />} />
        <Route path="/participantes/:procesoId" element={<ParticipantesPage />} />
        <Route path="/cabina" element={<CabinaPage />} />
        <Route path="/compositor/:procesoId" element={<CompositorPage />} />
        <Route path="/pantalla/:sesionId" element={<PantallaPage />} />
        <Route path="/propuesta/:procesoId" element={<PropuestaPage />} />
        <Route path="/tablero/:procesoId" element={<DashboardPage />} />
        <Route path="/nuevo" element={<NuevoPage />} />
      </Route>

      {/* Cualquier otra ruta vuelve a la decisión de entrada */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
